import {
  Button,
  DialogTitle,
  Dialog,
  DialogContent,
  DialogActions,
  FormControl,
  Notification,
  DatePicker,
  Stack,

} from '@xbotvn/mui';
import {
  filter, findIndex, get, keyBy, map,
} from 'lodash';
import moment from 'moment';
import PropTypes from 'prop-types';
import React, {
  useState,
  useMemo,
  useEffect,
} from 'react';
import {
  useDispatch,
  useSelector,
} from 'react-redux';

import SingleSelect from '../../../components/SingleSelect';
import {
  BORROW,
} from '../../../redux/actions/constants';

export default function Storage({
  data,
  onClose,
}) {
  const dispatch = useDispatch();

  const {
    selectedDocument,
    membersUnit,
    members,
    activeUnit,
    userInfo,
  } = useSelector(({
    unit,
    user,
    member,
    document,
  }) => ({
    members: member.data,
    selectedDocument: get(document.data, data.documentId, {}),
    membersUnit: get(unit, ['data', user.activeUnit, 'members'], []),
    activeUnit: user.activeUnit,
    userInfo: user,
  }));

  const isUnitMember = findIndex(membersUnit, (member) => member.email === userInfo.email);
  const isStudent = isUnitMember === -1 && !userInfo?.support;

  const [selectedUser, setSelectedUser] = useState('');
  const [borrowDate, setBorrowDate] = useState(new Date());
  const [requiredReturnDate, setRequiredReturnDate] = useState(new Date());

  useEffect(() => {
    setRequiredReturnDate(moment(borrowDate)
      .add(15, 'days')
      .toString());
  }, [borrowDate]);

  useEffect(() => {
    if (isStudent) setSelectedUser(userInfo.email);
    else setSelectedUser('');
  }, [isStudent]);

  const borrowers = useMemo(() => {
    if (isStudent) {
      return {
        [userInfo.email]: userInfo,
        ...keyBy(members, 'email'),
      };
    } return ({
      ...keyBy(membersUnit, 'email'),
      ...keyBy(filter(members, (mb) => new Date() < new Date(mb.endDate)), 'email'),
    });
  }, [members, membersUnit]);

  return (
    <Dialog
      open
      fullWidth
      onClose={onClose}
    >
      <DialogTitle>{`${selectedDocument?.name ?? ''} - ${selectedDocument?._id ?? ''}`}</DialogTitle>
      <DialogContent>
        <Stack direction="row">
          <DatePicker
            label="Ngày mượn"
            value={moment(borrowDate).toDate()}
            onChange={(date) => setBorrowDate(date)}
          />
          <DatePicker
            label="Ngày Phải trả"
            value={moment(requiredReturnDate).toDate()}
            onChange={(date) => setRequiredReturnDate(date)}
          />
        </Stack>
        <FormControl sx={{ minWidth: 250 }} size="small">
          <SingleSelect
            disabled={isStudent}
            options={map(borrowers, ({ name, email }) => (
              {
                label: name,
                value: email,
              }
            ))}
            placeholder="Chọn người mượn"
            onChange={setSelectedUser}
            value={selectedUser}
          />
        </FormControl>
      </DialogContent>
      <DialogActions>
        <Button
          color="primary"
          onClick={() => {
            const filterUser = filter(borrowers, ({ email }) => email === selectedUser);
            if (new Date() > new Date(filterUser[0]?.endDate)) {
              Notification.warn('Tài khoản đã hết hạn vui lòng liên hệ quản lý thư viện để gia hạn.');
              return;
            }
            if (borrowDate > requiredReturnDate) {
              Notification.warn('Ngày phải trả phải từ ngày cho mượn trở đi.');
              return;
            }
            if (!borrowers[selectedUser]) {
              Notification.warn('Chưa chọn người mượn.');
              return;
            }
            dispatch({
              type: BORROW.handlers.update,
              data: {
                documentItem: data._id,
                documentId: selectedDocument._id,
                borrowDate: borrowDate.toString(),
                requiredReturnDate: requiredReturnDate.toString(),
                status: 'request',
                userInfo: borrowers[selectedUser],
                unitId: activeUnit,
              },
            });
            onClose();
          }}
        >
          Mượn
        </Button>
        <Button
          onClick={onClose}
        >
          Huỷ
        </Button>
      </DialogActions>
    </Dialog>
  );
}

Storage.propTypes = {
  data: PropTypes.shape().isRequired,
  onClose: PropTypes.func.isRequired,
};
